export const API_TOKEN = 'authToken';
